var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('List',{attrs:{"fields":_vm.fields,"model":_vm.model,"title":_vm.title,"subtitle":_vm.subtitle,"crumbs":_vm.crumbs,"url":_vm.url,"user":_vm.user,"url-tipe":"baut","tipe":"OLO_BAUT"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }